import { formatPriceByStoreLocale } from 'lib/shopify';
import useAddonDiscount from 'hooks/shop/useAddonDiscount';
import styles from './cartDiscountPrice.module.scss';

const CartDiscountPrice = ({ shopifyData, locale, addonConfigs, children }) => {
  const { isAddonProduct, hasQualifyingCartItem, salePrice } = useAddonDiscount(
    addonConfigs,
    locale,
    shopifyData
  );

  if (!isAddonProduct || !hasQualifyingCartItem || !salePrice) return children || null;

  return (
    <div className={styles.cartDiscountPrice}>
      <span className={styles.salePrice}>
        {formatPriceByStoreLocale({ locale, price: salePrice })}
      </span>
      <span className={styles.originalPrice}>
        {formatPriceByStoreLocale({ locale, price: shopifyData?.productPrice })}
      </span>
    </div>
  );
};

export default CartDiscountPrice;
